import React from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_ham_and_cheese_bake.png";
import useMetaTracking from "../hooks/useMetaTracking";

function VeganHamAndCheeseHotBake() {
  useMetaTracking("ViewContent", {
    content_name: "Vegan Ham & Cheese Hot Bake",
    content_category: "Vegan Menu",
    content_ids: ["vegan_ham_and_cheese_hot_bake"],
    content_type: "vegan_pastries",
    value: 3.50,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Vegan Ham & Cheese Hot Bake | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Flaky puff pastry filled with vegan deli meats and creamy vegan cheese."
        />
        <meta
          property="og:title"
          content="Vegan Ham & Cheese Hot Bake | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="Flaky puff pastry filled with vegan deli meats and creamy vegan cheese."
        />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="VEGAN HAM & CHEESE HOT BAKE"
          titleSubHead="$3.50 each"
          detailBody="Flaky puff pastry filled with vegan deli meats and creamy vegan cheese. No utensils, no fuss - just a perfectly vegan hot bake you can enjoy anytime, anywhere."
          detailBodyBr="Contains: wheat, soy, almond, sesame"
          detailBody3="Available now!"
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default VeganHamAndCheeseHotBake;